import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './components/login-form/login-form.component';

const routes: Routes = [
  { path: 'login', component: LoginFormComponent },
  {
    path: 'shiftleader-dashboard',
    loadChildren: () =>
      import('../../projects/shiftleader-dashboard/src/app/app.module').then(
        (module) => module.AppModule,
      ),
  },
  {
    path: 'operator-cockpit',
    loadChildren: () =>
      import('../../projects/operator-cockpit/src/app/app.module').then(
        (module) => module.AppModule,
      ),
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
